import api from './api';

// Helper para extrair dados da resposta
const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const paymentsService = {
  // Retorna todos os métodos de pagamento do usuário (globais + customizados)
  getAll: async () => {
    const response = await api.get('/payments');
    return extractData(response.data);
  },

  // Retorna as formas de pagamento globais
  getGlobal: async () => {
    const response = await api.get('/payments/global');
    return extractData(response.data);
  },

  // Retorna as formas de pagamento disponíveis para o usuário (globais + customizadas)
  getAvailable: async () => {
    const response = await api.get('/payments/available');
    return extractData(response.data);
  },

  // Buscar método de pagamento por ID
  getById: async (id) => {
    const response = await api.get(`/payments/${id}`);
    return extractData(response.data);
  },

  // Criar nova forma de pagamento customizada
  create: async (data) => {
    const response = await api.post('/payments', data);
    return extractData(response.data);
  },

  // Atualizar forma de pagamento customizada (somente do próprio usuário)
  update: async (id, data) => {
    const response = await api.put(`/payments/${id}`, data);
    return extractData(response.data);
  },

  // Deletar forma de pagamento customizada (somente do próprio usuário)
  delete: async (id) => {
    const response = await api.delete(`/payments/${id}`);
    return response.data;
  },
};

export default paymentsService;
